import { createTypes } from 'redux-create-types';
import * as axios from 'axios';
import { ajaxJson, ajaxFD } from 'imports/ajax';
import { sleep } from 'imports/utils';
import { 
    map2DiscussionObj,
    map2PostObj,
    map2TopicObj,
    map2CourseObj,
    map2ForumAttachments
} from 'imports/mapper';
import { courseActionCreators } from 'db/course/course.action';
import { topicActionsCreators } from 'db/topic/topic.action';
import { discussionActionsCreators } from 'db/discussion/discussion.action';
import { replyActionsCreators } from 'db/reply/reply.action';
import { forumAttachmentsActionsCreators } from 'db/forum-attachment/forum-attachments.action';
import { coursePageActionsCreators } from '../../CourseActions';
import { postAttachmentsSelectorFnMaker } from './ForumSelectors';
import { createSelector } from 'redux-orm';
import { orm, dbStateSelector } from 'db';
import { toast } from 'react-toastify';


const namespace = 'page-forum';

export const forumActions = createTypes([
    'setPostList',
    'setDiscussionsList',
    'setTopicList',
    'toggleSpinner',
    'setError',
    'addCancelTokenSource',
    'setForumAttachmentUploadingProgress',
    'toggleSelectTopic',
    'postFormSetReply',
    'postFormClearReply',
    'postFormSetContent',
    'postFormClearContent',
    'postFormSetAttachments',
    'postFormClearAttachments',
    'deletePostFormAttachment',
    'setSelectedDiscussion',
    'setSelectedPostIdToEdit',
    'setActiveTopic',
    'setSearchResult',
    'hideSearchSpinner',
    'setUsersList',
    'showSearchSpinner',
    'setMentionedStudents',
    'toggleShowSearchUser',
    'hideShowSearchUser',
    'removeMentionedUser'
], namespace);


function hideShowSearchUser() {
    return dispatch => {
        dispatch({
            type: forumActions.hideShowSearchUser
        })
    }
}

function toggleShowSearchUser(payload) {
    return dispatch => {
        dispatch({
            type: forumActions.toggleShowSearchUser,
            payload: payload
        })
    }
}

function postFormSetReply(reply) {
    return dispatch => {
        dispatch({
            type: forumActions.postFormSetReply,
            payload: reply
        })
    }
}

function postFormClearReply() {
    return dispatch => {
        dispatch({
            type: forumActions.postFormClearReply,
        })
    }
}

function postFormSetContent(content) {
    return dispatch => {
        dispatch({
            type: forumActions.postFormSetContent,
            payload: content,
        })
    }
}

function postFormClearContent() {
    return dispatch => {
        dispatch({
            type: forumActions.postFormClearContent,
        })
    }
}

function showSpinner(apiName) {
    return dispatch => {
        dispatch({
            type: forumActions.toggleSpinner,
            payload: true,
            meta: {apiName}
        });
    }
}

function hideSpinner(apiName) {
    return dispatch => {
        dispatch({
            type: forumActions.toggleSpinner,
            payload: false,
            meta: {apiName}
        });
    }
}

function setTopicList(ids) {
    return dispatch => {
        dispatch({
            type: forumActions.setTopicList,
            payload: ids
        })
    }
}

function setActiveTopicId(id) {
    return dispatch => {
        dispatch({
            type: forumActions.setActiveTopic,
            payload: id
        })
    }
}

function getTopicApiSuccess(res) {
    return (dispatch, getState) => {
        const topicIds = res.data.map(t => (map2TopicObj(t).id));
        res.data.forEach((topic) => {
            const topicObj = map2TopicObj(topic);
            if (topicObj.active) {
                dispatch(setActiveTopicId(topicObj.id))
            }
            dispatch(topicActionsCreators.saveTopic(topicObj));
        });
        dispatch(setTopicList(topicIds));
        dispatch(hideSpinner('topics'));
    }
}

function getTopicApiFailed(err) {
    return dispatch => {
        dispatch({
            type: forumActions.setError,
            payload: err,
            meta: {apiName: 'topics'}
        })
        dispatch(hideSpinner('topics'));
    }
}

function getTopicFromApi(programId, courseId) {
    return dispatch => {
        dispatch(showSpinner('topics'));
        ajaxJson.get(`/programs/${programId}/courses/${courseId}/topics`)
        .then(
            res => dispatch(getTopicApiSuccess(res)),
            err => dispatch(getTopicApiFailed(err)),
        )
    }
}

function getCourseApiSuccess(res) {
    return dispatch => {
        const courseObj = map2CourseObj(res.data);
        dispatch(courseActionCreators.save(courseObj))
        dispatch(coursePageActionsCreators.setBreadCrumb([
            {
                title: courseObj.title,
                order: 0,
            },
            {
                title: 'تالار گفتمان',
                order: 1,
            },
        ]))
        dispatch(hideSpinner('course'));
    }
}

function getCourseApiFail(err) {
    return dispatch => {
        dispatch({
            type: forumActions.setError,
            payload: err,
            meta: {apiName: 'topics'}
        })
        dispatch(hideSpinner('course'));
    }
}

function getCourseFromApi(courseId) {
    return dispatch => {
        dispatch(showSpinner('course'));
        ajaxJson.get(`/courses/${courseId}`).then(
            res => dispatch(getCourseApiSuccess(res)),
            err => dispatch(getCourseApiFail(err)),
        );        
    }
}

function setDiscussionsList(ids) {
    return dispatch => {
        dispatch({
            type: forumActions.setDiscussionsList,
            payload: ids
        })
    }
}

function getDiscussionsApiSuccess(res, topicId) {
    return (dispatch,getState) => {
        let discussionIds = res.data.map(discussion => (map2DiscussionObj(discussion).id));
        res.data.map(discussion => {
            const discussionObj = map2DiscussionObj(discussion);
            return dispatch(discussionActionsCreators.saveDiscussion(discussionObj, topicId));
        });
        dispatch(setDiscussionsList(discussionIds));
        dispatch(hideSpinner('discussions'));
    }
}

function getDiscussionsApiFail(err) {
    return dispatch => {
        dispatch({
            type: forumActions.setError,
            payload: err,
            meta: {apiName: 'topics'}
        })
        dispatch(hideSpinner('discussions'))
    }
}

function getDiscussionsFromApi(topicId) {
    return dispatch => {
        dispatch(showSpinner('discussions'));
        return ajaxJson.get(`/forums/topics/${topicId}/discussions`)
        .then(
            res => (dispatch(getDiscussionsApiSuccess(res, topicId))),
            err => (dispatch(getDiscussionsApiFail(err))),
        )
    }
}

function getDiscussionApiSuccess(res, topicId) {
    return dispatch => {
        const discussionObj = map2DiscussionObj(res.data);
        dispatch(discussionActionsCreators.saveDiscussion(discussionObj, topicId));
        dispatch(hideSpinner('discussion'));
    }
}

function getDiscussionApiError(err) {
    return dispatch => {
        dispatch({
            type: forumActions.setError,
            payload: err,
            meta: {apiName: 'discussion'}
        })
        dispatch(hideSpinner('discussion'));
    }
}

function getDiscussionFromApi(topicId, discussionId) {
    return dispatch => {
        dispatch(showSpinner('discussion'));
        return ajaxJson.get(`/forums/topics/${topicId}/discussions/${discussionId}`)
        .then(
            res => dispatch(getDiscussionApiSuccess(res, topicId)),
            err => dispatch(getDiscussionApiError(err)),
        )
    }
}

function setPostList(ids) {
    return dispatch => {
        return dispatch({
            type: forumActions.setPostList,
            payload: ids,
        })
    }
}

function getDiscussionPostsApiSuccess(res, discussionId, topicId) {
    return dispatch => {
        let postIds = res.data.map(post => map2PostObj(post).id);
        res.data.forEach(post => {
            const postObj = map2PostObj(post);
            dispatch(replyActionsCreators.addPost(postObj, discussionId))
            dispatch(forumAttachmentsActionsCreators.deleteAllPostAttachment(postObj.id));
            postObj.attachments.forEach(attachment => {
                dispatch(forumAttachmentsActionsCreators.createAttachment(
                    attachment.id,
                    '',
                    attachment.url,
                    attachment.fileType,
                    'uploaded',
                    postObj.id,
                    attachment.image
                ));
            });
        });
        dispatch(setPostList(postIds));
        dispatch(hideSpinner('posts'));
    } 
}

function getDiscussionPostsApiFail(err) {
    return dispatch => {
        dispatch({
            type: forumActions.setError,
            payload: err,
            meta: {apiName: 'posts'}
        })
        dispatch(hideSpinner('posts'));
    } 
}

function getDiscussionPostsFromApi(topicId, discussionId) {
    return dispatch => {
        dispatch(showSpinner('posts'));        
        return ajaxJson.get(`/forums/topics/${topicId}/discussions/${discussionId}/posts`)
        .then(
            res => dispatch(getDiscussionPostsApiSuccess(res, discussionId, topicId)),
            err => dispatch(getDiscussionPostsApiFail(err)),
        )
    }
}

function postDiscussionApiSuccess(res, topicId) {
    return dispatch => {
        return dispatch(getDiscussionFromApi(topicId))
    }
}

function postDiscussionApiFail(err) {
    return dispatch => {
        dispatch({
            type: forumActions.setError,
            payload: err,
            meta: {apiName: 'save-discussion'}
        })
        dispatch(hideSpinner('save-discussion'));
    }
}

function postDiscussionToApi(topicId, discussionData) {
    return dispatch => {
        dispatch(showSpinner('save-discussion'));        
        return ajaxJson.post(`/forums/topics/${topicId}/discussions`, {
            "title": discussionData.title,
            "content": discussionData.content,
        })
        .then(
            res => dispatch(postDiscussionApiSuccess(res, topicId)),
            err => dispatch(postDiscussionApiFail(err)),
        )
    }
}

function postPostApiSuccess(res, topicId, discussionId) {
    return dispatch => {
        dispatch(forumAttachmentsActionsCreators.deleteAllDraftAttachment());
        dispatch(getDiscussionPostsFromApi(topicId, discussionId));
        dispatch(discussionActionsCreators.increasePostCount(discussionId));
        dispatch(hideSpinner('save-post'));
        dispatch(removeMentionedUser([]))       
        dispatch(postFormClearContent());
        dispatch(postFormClearReply());
        toast.success('پاسخ شما با موفقیت ارسال شد.');
    }
}

function postPostApiFail(err) {
    return dispatch => {
        dispatch({
            type: forumActions.setError,
            payload: err,
            meta: {apiName: 'save-post'}
        })
        dispatch(hideSpinner('save-post'));
    }
}

function postPostToApi(topicId, discussionId, replyData, mentionedStudents) {
    return dispatch => {
        dispatch(showSpinner('save-post'));        
        let attachmentsId = null;
        if (replyData.attachments && Array.isArray(replyData.attachments)) {
            attachmentsId = replyData.attachments.map(a => a.id);
        }
        let mentionedStudentsIds = []
        mentionedStudents.map((mentionedStudent, index) => {
            mentionedStudentsIds.push(mentionedStudent.uid)
        })
        if (replyData.attachments.length === 0){
            if (replyData.content === '<div style="text-align: right"><p><br></p></div>') {
                replyData.content = ""
            }
        }
        
        return ajaxJson.post(`/forums/topics/${topicId}/discussions/${discussionId}/posts`, {
            "title": '.',
            "content": replyData.content,
            "reply_to": replyData.reply && replyData.reply.postId,
            "attachment_uids": attachmentsId,
            "mentioned_students_uids": mentionedStudentsIds
        }).then(
            res => dispatch(postPostApiSuccess(res, topicId, discussionId)),
            err => dispatch(postPostApiFail(err)),
        );
    }
}

function patchPostApiSuccess(res, {topicId, discussionId, id, replyData}) {
    return dispatch => {
        return dispatch(getDiscussionPostsFromApi(topicId, discussionId))
        .then(() => {
            dispatch(hideSpinner('update-post'));
            dispatch(postFormClearContent());
            dispatch(postFormClearReply());
            dispatch(deSelectPostIdToEdit());
            toast.success('پست ویرایش شد.');
        })
    }
}

function patchPostApiFail(err) {
    return dispatch => {
        dispatch({
            type: forumActions.setError,
            payload: err,
            meta: {apiName: 'update-post'}
        })
        return dispatch(hideSpinner('update-post'));
    }
}

function patchPostToApi(topicId, discussionId, id, replyData, mentionedStudents) {
    return dispatch => {
        dispatch(showSpinner('update-post'));
        let attachmentsId = null;
        if (replyData.attachments && Array.isArray(replyData.attachments)) {
            attachmentsId = replyData.attachments.map(a => a.id);
        }
        let mentionedStudentsIds = []
        mentionedStudents.map((mentionedStudent, index) => {
            mentionedStudentsIds.push(mentionedStudent.uid)
        })
        return ajaxJson.patch(`/forums/topics/${topicId}/discussions/${discussionId}/posts/${id}`, {
            "title": '.',
            "content": replyData.content,
            "attachment_uids": attachmentsId,
            "mentioned_students_uids": mentionedStudentsIds
        }).then(
            res => dispatch(patchPostApiSuccess(res, {topicId, discussionId, id, replyData})),
            err => dispatch(patchPostApiFail(err)),
        )
    }
}

function deleteReplyApiSuccess(res, id, discussionId) {
    return dispatch => {
        dispatch(replyActionsCreators.removePost(id));
        dispatch(discussionActionsCreators.decreasePostCount(discussionId));
        dispatch(hideSpinner('delete-post'));
    }
}

function deleteReplyApiFail(err) {
    return dispatch => {
        dispatch({
            type: forumActions.setError,
            payload: err,
            meta: {apiName: 'delete-post'}
        });
        return dispatch(hideSpinner('delete-post'));
    }
}

function deleteReplyToApi(topicId, discussionId, id) {
    return dispatch => {
        dispatch(showSpinner('delete-post'));
        return ajaxJson.delete(`/forums/topics/${topicId}/discussions/${discussionId}/posts/${id}`)
        .then(
            res => dispatch(deleteReplyApiSuccess(res, id, discussionId)),
            err => dispatch(deleteReplyApiFail(err)),
        )
    }
}

function makeCancelTokenForUploadAttachment(id) {
    return dispatch => {
        const cancelTokenSource = axios.CancelToken.source();        
        return dispatch({
            type: forumActions.addCancelTokenSource,
            payload: cancelTokenSource,
            meta: {
                id
            }
        })
    }
}

function uploadForumAttachmentApiSuccess(res, id) {
    return dispatch => {
        const obj = map2ForumAttachments(res.data);
        dispatch(forumAttachmentsActionsCreators.setAttachmentCorrectValue(id, obj.id, obj.url, null));
        dispatch(hideSpinner('upload-attachment'));
    }
}

function uploadForumAttachmentApiFail(err, id) {
    return dispatch => {
        const dispatch1 = dispatch(forumAttachmentsActionsCreators.deleteAttachment(id));
        const dispatch2 = dispatch({
            type: forumActions.setError,
            payload: err,
            meta: {apiName: 'upload-attachment'}
        });
        dispatch(hideSpinner('upload-attachment'));
        return Promise.all(dispatch1, dispatch2);
    }
}

function uploadForumAttachmentToApi(id, formData) {
    return (dispatch, getState) => {
        const cancelTokenSource = getState().ui.forum.cancelTokenSources[id];
        dispatch(showSpinner('upload-attachment'));        
        ajaxFD.post(`/forums/posts/attachments`, formData, {
            onUploadProgress: function (progressEvent) {
                const progress = Math.trunc((progressEvent.loaded / progressEvent.total) * 100);
                dispatch({
                    type: forumActions.setForumAttachmentUploadingProgress,
                    payload: {
                        progress,
                        id
                    }
                });
            },
            cancelToken: cancelTokenSource.token,
        }).then(
            res => dispatch(uploadForumAttachmentApiSuccess(res, id)),
            err => dispatch(uploadForumAttachmentApiFail(err, id)),
        )
    }
}

function makeUploadForumAttachmentFormData(id, file) {
    return dispatch => {
        const formData = new FormData();
        formData.append('file', file);
        dispatch(uploadForumAttachmentToApi(id, formData));
    }
}

function uploadForumAttachment(file) {
    return dispatch => {
        const id = `n${Date.now()}`;
        const URL = window.URL || window.webkitURL;
        dispatch(forumAttachmentsActionsCreators.createAttachment(id, file.name, URL.createObjectURL(file), 'document', 'uploading', null));
        dispatch(makeCancelTokenForUploadAttachment(id))
        dispatch(makeUploadForumAttachmentFormData(id, file));
        sleep(1);
    }
}

function postLikePostApiSuccess(res, id) {
    return dispatch => {
        if (res.status === 201)  {
            dispatch(replyActionsCreators.likePost(id, true));
        }

        if (res.status === 204)  {
            dispatch(replyActionsCreators.likePost(id, false));                    
        }
    }
}

function postLikePostApiFail(err) {
    return dispatch => {
        return dispatch({
            type: forumActions.setError,
            payload: err,
            meta: {apiName: 'like-post'}
        })
    }
}

function postLikePostToApi(topicId, discussionId, id) {
    return dispatch => {
        return ajaxJson.post(`/forums/topics/${topicId}/discussions/${discussionId}/posts/${id}/likes`)
        .then(
            res => dispatch(postLikePostApiSuccess(res, id)),
            err => dispatch(postLikePostApiFail(err)),
        )
    }
}

function cancelUploadingAttachment(id) {
    return (dispatch, getState) => {
        const targetCancelSource = getState().cancelTokens.find((item => (item.id === id)));
        if (targetCancelSource && targetCancelSource.cancel) {
            targetCancelSource.cancel('انصراف از آپلود.');
        }
    }
}

function selectTopic(topicId) {
    return dispatch => {
        dispatch(setDiscussionsList([]));
        dispatch({
            type: forumActions.toggleSelectTopic,
            payload: {id: topicId, state: true},
        });
    }
}

function deselectTopic(topicId) {
    return dispatch => {
        dispatch(setDiscussionsList([]));
        dispatch({
            type: forumActions.toggleSelectTopic,
            payload: {id: topicId, state: false},
        });
    }
}

function selectPostIdToEdit(postId, content) {
    return (dispatch, getState) => {
        dispatch({
            type: forumActions.setSelectedPostIdToEdit,
            payload: postId,
        });
        const attachments = createSelector(orm, dbStateSelector, postAttachmentsSelectorFnMaker(postId))(getState());
        dispatch({
            type: forumActions.postFormSetAttachments,
            payload: attachments,
        });
    }
}

function deSelectPostIdToEdit() {
    return dispatch => {
        dispatch({
            type: forumActions.setSelectedPostIdToEdit,
            payload: null
        });
        dispatch(forumAttachmentsActionsCreators.deleteAllDraftAttachment());
        dispatch({
            type: forumActions.postFormClearAttachments,
        });
    }
}

function savePost(replyData) {
    return (dispatch, getState) => {
        const forumPageState = getState().ui.forum;
        if (forumPageState.selectedPostIdToEdit) {
            dispatch(forumActionsCreator.patchPostToApi(forumPageState.selectedTopic, forumPageState.selectedDiscussion, forumPageState.selectedPostIdToEdit, replyData, forumPageState.mentionedStudents));
        } else {
            dispatch(forumActionsCreator.postPostToApi(forumPageState.selectedTopic, forumPageState.selectedDiscussion, replyData, forumPageState.mentionedStudents));
        }
    }
}

function selectDiscussion(discussionId) {
    return dispatch => {
        dispatch({
            type: forumActions.setSelectedDiscussion,
            payload: discussionId,
        });
    }
}

function deSelectDiscussion() {
    return dispatch => {
        dispatch({
            type: forumActions.setSelectedDiscussion,
            payload: null
        });
    }
}

function deletePostFormAttachment(attachmentId) {
    return dispatch => {
        dispatch({
            type: forumActions.deletePostFormAttachment,
            payload: attachmentId
        });
    }
}

function getSearchResultApiSuccess(res) {
    return dispatch => {
        dispatch({
            type: forumActions.setSearchResult,
            payload: res.data,
        })
    }
}

function getSearchResultApiFail(err) {
    return dispatch => {
        return dispatch({
            type: forumActions.setError,
            payload: err,
            meta: {apiName: 'search'}
        })
    }
}

function getSearchResultFromApi(programId, courseId, terms) {
    return dispatch => {
        dispatch(showSpinner('search'));
        ajaxJson.get(`/programs/${programId}/courses/${courseId}/search`, { params: {
            q: terms,
        }})
        .then(
            res => dispatch(getSearchResultApiSuccess(res)),
            err => dispatch(getSearchResultApiFail(err)),
        )
        .then(() => {
            dispatch(hideSpinner('search'));
        })
    }
}


function showSearchSpinner() {
    return dispatch => {
        dispatch({
            type: forumActions.showSearchSpinner,
            payload: true
        })
    }
}

function setMentionedStudents(studentsIds) {
    return dispatch => {
        dispatch({
            type: forumActions.setMentionedStudents,
            payload: studentsIds
        })
    }
}

function setUsersList(users) {
    return dispatch => {
        dispatch({
            type: forumActions.setUsersList,
            payload: users
        })
    }
}

function hideSearchSpinner() {
    return dispatch => {
        dispatch({
            type: forumActions.hideSearchSpinner,
            payload: false
        })
    }
}

function searchUsersApiSuccess(res) {
    return dispatch => {
        dispatch(hideSearchSpinner())
        const users = res.data.staff.concat(res.data.classmates)
        dispatch(setUsersList(users));
    }
}

function searchUsersApiFail(err) {
    return dispatch => {
        dispatch(hideSearchSpinner())
        dispatch({
            type: forumActions.setError,
            payload: err,
            meta: { apiName: 'topics' }
        })
    }
}

function searchUsersFromApi(queryText, programId, courseId) {
    return dispatch => {
        dispatch(showSearchSpinner())
        return ajaxJson.get(`/programs/${programId}/courses/${courseId}/search_users`, { params: { q: queryText } })
            .then(
                res => dispatch(searchUsersApiSuccess(res)),
                err => dispatch(searchUsersApiFail(err))
            )
    }
}

function removeMentionedUser(payload) {
    return dispatch => {
        dispatch({
            type: forumActions.removeMentionedUser,
            payload: payload,
        })
    }
}


export const forumActionsCreator = {
    getTopicFromApi,
    getCourseFromApi,
    getDiscussionsFromApi,
    getDiscussionFromApi,
    getDiscussionPostsFromApi,
    postDiscussionToApi,
    postPostToApi,
    patchPostToApi,
    deleteReplyToApi,
    postLikePostToApi,
    uploadForumAttachment,
    cancelUploadingAttachment,
    selectTopic,
    deselectTopic,
    postFormSetReply,
    postFormClearReply,
    postFormSetContent,
    postFormClearContent,
    selectPostIdToEdit,
    deSelectPostIdToEdit,
    savePost,
    selectDiscussion,
    deSelectDiscussion,
    deletePostFormAttachment,
    getSearchResultFromApi,
    searchUsersFromApi,
    setMentionedStudents,
    toggleShowSearchUser,
    hideShowSearchUser,
    removeMentionedUser
}
